import React from "react";
import "./Services.css";

const services = [
  {
    title: "Cloud Data Engineering",
    description:
      "We create reliable and scalable cloud data systems that help your business securely collect, store, and manage data with ease. Our cloud solutions enable faster access to important information, reduce costs, and support your growth by providing a strong foundation for all your data needs.",
  },
  {
    title: "Cybersecurity & Compliance",
    description:
      "We protect your business from evolving cyber threats with comprehensive security solutions tailored to your needs. Our team ensures your systems and data are safe, compliant with industry regulations, and resilient—so you can focus on growing your business with confidence.",
  },
  {
    title: "Test Engineering and Automation",
    description:
      "We deliver comprehensive automated and manual testing solutions that enhance software quality and accelerate release cycles. Our services include continuous integration testing, performance validation, and defect management, all tailored to your specific business requirements.",
  },
  {
    title: "Data Analytics & Business Intelligence",
    description:
      "We transform your raw data into actionable insights through advanced analytics, business intelligence, and robust data management. Tailored to your business needs, our solutions help you visualize trends, monitor performance, and make informed decisions that drive sustainable growth.",
  },
  {
    title: "Intelligent Automation (RPA)",
    description:
      "We design and deploy intelligent automation solutions that streamline repetitive business processes, improve efficiency, and reduce operational costs. Leveraging robotic process automation (RPA) and AI-driven workflows, we help your organization achieve faster turnaround times, increased accuracy, and enhanced scalability.",
  },
  {
    title: "Technical Resource Augmentation",
    description:
      "Access experienced IT professionals to enhance team capabilities and speed up project completion. Flexible resource augmentation delivers the right skills at the right time, supporting efficient growth, lowering recruitment costs, and helping maintain focus on strategic priorities.",
  },
];

const Services = () => {
  return (
    <section className="services-section" id="services">
      <h2 className="services-title">Our Services</h2>
      <div className="services-container">
        {services.map(({ title, description }, index) => (
          <div key={index} className="service-card">
            <h3 className="service-title">{title}</h3>
            <p className="service-description">{description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Services;
